import React from 'react';
import PropTypes from 'prop-types';
// import classnames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as filledStar } from '@fortawesome/free-solid-svg-icons/faStar';

import styles from './StarRating.css';

const cx = className => styles[className];

const SIZE_MAP = {
  sm: 'sm',
  md: '2x',
  lg: '3x',
};

const StarGroup = React.memo(({ size, numberOfStars }) => Array.from(Array(numberOfStars).keys()).map(
  i => <FontAwesomeIcon key={i} icon={filledStar} size={size} />,
));

StarGroup.propTypes = {
  size: PropTypes.string.isRequired,
  numberOfStars: PropTypes.number,
};

StarGroup.defaultProps = {
  numberOfStars: 5,
};

// eslint-disable-next-line react/no-multi-comp
const StarRating = React.memo(({ starCount, reviewCount, size, numberOfStars }) => (
  <div className={cx('rating')}>
    <div className={cx('stars')}>
      <span className={cx('starsBack')}>
        <StarGroup size={SIZE_MAP[size]} numberOfStars={numberOfStars} />
      </span>
      <span className={cx('starsFront')} style={{ width: `${starCount / 5 * 100}%` }}>
        <StarGroup size={SIZE_MAP[size]} numberOfStars={numberOfStars} />
      </span>
    </div>

    {reviewCount && (
      <div className={cx('count')}>{reviewCount}</div>
    )}
  </div>
));

StarRating.displayName = 'StarRating';

StarRating.propTypes = {
  starCount: PropTypes.number.isRequired,
  reviewCount: PropTypes.number,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  numberOfStars: PropTypes.number,
};

StarRating.defaultProps = {
  size: 'sm',
  reviewCount: undefined,
  numberOfStars: 5,
};

export default StarRating;
